import { setLegendStatusText } from './dom';
import { getMapStatusThemeFromState } from './state';
import type { MapApiResult, MapPageDom, MapState } from './types';

/**
 * Renders the legend cards from the API payload so later stages only replace details, not structure.
 *
 * @param params Page DOM, validated map payload and runtime state containing API theme tokens.
 * @returns Nothing. Replaces the legend-card DOM and associated status text.
 */
export function renderLegend(params: {
  mapDom: MapPageDom;
  mapData: MapApiResult;
  state: MapState;
}): void {
  const { mapDom, mapData, state } = params;

  mapDom.legendItems.innerHTML = '';

  if (mapData.legend.length === 0) {
    setLegendStatusText({
      mapDom,
      text: 'Легенда карты пуста.',
    });

    return;
  }

  for (const legendItem of mapData.legend) {
    const themeItem = getMapStatusThemeFromState({
      state,
      statusCode: legendItem.status,
    });

    const card = document.createElement('article');
    card.className = 'rounded-xl border px-4 py-3';
    card.style.backgroundColor = themeItem.fillColor;
    card.style.borderColor = themeItem.stroke;
    card.style.color = themeItem.textColor;

    const title = document.createElement('p');
    title.className = 'text-sm font-semibold uppercase tracking-widest';
    title.textContent = `${legendItem.count}`;

    const description = document.createElement('p');
    description.className = 'mt-2 text-sm leading-snug';
    description.textContent = legendItem.description;

    card.append(title, description);
    mapDom.legendItems.append(card);
  }

  setLegendStatusText({
    mapDom,
    text: '',
  });
}
